<template>
	<div id="app">
		<Header ref="header" @openModalCode="openModalCode(true)" @openModalDifficulty="openModalDifficulty"/>

		<transition appear name="fade" mode="out-in">
			<router-view :key="$route.fullPath" @checkSession="checkSession" />
		</transition>

		<ModalTerms ref="modalTerms" @submit="onFormSubmit" />
		<ModalCode ref="modalCode" />
		<ModalDifficulty ref="modalDifficulty" />
	</div>
</template>



<script>
import Header from './components/Header.vue';
import Login from './views/Login.vue';
import ModalTerms from './components/modals/ModalTerms.vue';
import ModalCode from './components/modals/ModalCode.vue';
import ModalDifficulty from './components/modals/ModalDifficulty.vue';

export default {
	components: { Header, Login, ModalTerms, ModalCode, ModalDifficulty },
	data() {
		return {
			sessionCode: null,
			classroomCode: null,
			behavior: null,
			debug: null,

			sessionLoaded: false,
			tasksLoaded: false,

			onSessionLoadEvent: new Event('onSessionLoad'),
		};
	},
	methods: {
		onFocus() {
			this.$log.onWindowFocus(true);
		},
		onBlur() {
			this.$log.onWindowFocus(false);
		},

		fetchTasks() {
			// Fetch data about all modules and tasks
			this.fetch(`/api/get_modules/`, data => {
				if (data) {
					let modules = [];
					let tasks = [];
					for (let mod of data) {
						modules.push(mod);
						for (let task of mod.tasks) {
							tasks.push({ module: mod.name, task: task });
						}
					}

					this.$tracker.initTasks(modules, tasks);

					this.tasksLoaded = true;
					if (this.sessionLoaded) {
						window.dispatchEvent(this.onSessionLoadEvent);
					}
				}
				else {
					console.error(this.fetchError);
				}
			});
		},

		checkSession() {
			// Check if current session exists
			this.fetch(`/api/check_session/`, data => {
				if (data) {
					if (data.classroom) {
						this.sessionCode = data.session;
						this.classroomCode = data.classroom;
						this.behavior = data.behavior;
						this.debug = data.debug;

						this.$tracker.initSession(data.session, data.classroom, data.behavior, data.debug, data.skip, data.performance, data.completed, data.evaluated);
						this.$log.initSession();

						this.sessionLoaded = true;

						if (!data.terms) {
							this.showTermsAndServices();
						}

						if (this.sessionCode && this.sessionCode != localStorage.sessionCode) {
							localStorage.sessionCode = this.sessionCode;
							this.openModalCode(false);
						}
					}

					if (!data.classroom) {
						this.$router.replace({ name: "Login" });
					}
					else if (this.$route.name == "Login") {
						this.$router.replace({ name: "Home" });
					}

					if (this.sessionCode && this.tasksLoaded) {
						window.dispatchEvent(this.onSessionLoadEvent);
					}
				}
				else {
					console.error(this.fetchError);
				}
			});
		},

		showTermsAndServices() {
			// if (localStorage.acceptedTerms) { return; }

			// this.$refs.modalTerms.open();

			// localStorage.acceptedTerms = true;

			// const messageVNode = this.$createElement('div', {}, [
			// 	this.$createElement('div', {
			// 		class: ['overflow-auto', 'p-3'],
			// 		style: {'height': '500px', 'box-shadow': 'inset 0px 0px 8px rgba(0,0,0,0.1)'}
			// 	},[
			// 		this.$createElement('div', {
			// 			class: ['overflow-auto'],
			// 			domProps: {
			// 				innerHTML: this.getText('product_terms_and_conditions')
			// 			}
			// 		})
			// 	]),
			// ])
			// // We must pass the generated VNodes as arrays
			// this.$bvModal.msgBoxOk([messageVNode], {
			// 	title: "Notice",
			// 	size: "lg",
			// 	centered: true,
			// 	okTitle: "Accept",
			// 	// hideHeaderClose: false,
			// 	noCloseOnBackdrop: true,
			// 	noCloseOnEsc: true,
			// })
			// .then(value => {
			// 	console.log('CLICKED', value);
			// 	if (value) {
			// 		localStorage.acceptedTerms = true;
			// 	}
			// })
			// .catch(err => {
			// 	console.warn('modal error', err);
			// })
		},

		onFormSubmit(data) {
			// console.log("SUBMIT:", data);
			// localStorage.acceptedTerms = true;

			// Submit terms and demographic data
			fetch("/api/submit_terms", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(data)
			})
			.then(response => response.json())
			.then(data => {
				if (!data.success) {
					console.warn("Upload fail:", data.error);
				}
			});
		},

		openModalCode(showLogout) {
			this.$refs.modalCode.open(this.sessionCode, showLogout);
		},

		openModalDifficulty() {
			this.$refs.modalDifficulty.open();
		},

		repairLocalStorage() {
			// Explored cards
			try {
				let data = JSON.parse(localStorage.getItem("exploredCards"));
				if (typeof data !== "object" || Array.isArray(data) || data === null) {
					throw new Error();
				}
			} catch (error) {
				localStorage.exploredCards = "{}";
			}
		},
	},
	computed: {
		header() {
			return this.$refs["header"];
		}
	},
	mounted() {
		window.onfocus = this.onFocus;
		window.onblur = this.onBlur;

		this.fetchTasks();
		this.checkSession();
		this.repairLocalStorage();
	}
};
</script>



<style>
	#app {
		display: flex;
		flex-direction: column;
		height: 100%;
		/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
		/*-webkit-font-smoothing: antialiased;*/
		/*-moz-osx-font-smoothing: grayscale;*/
		/*text-align: center;*/
		/*color: #2c3e50;*/
		/*margin-top: 60px;*/
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.3s ease-out;
	}
	.fade-enter, .fade-leave-active {
		opacity: 0;
	}

</style>
